module.exports = __webpack_public_path__ + "img/chaizen.5116bd86.jpeg";